<template>
  <div>
    <div style="margin-bottom: 15px">
      <span>选择学校：</span>
      <a-select v-model="bizOrgId" :allowClear="true" style="width: 15%">
        <a-select-option v-for="bizOrg in bizOrgList" :value="bizOrg.id" :key="bizOrg.id">
          {{ bizOrg.name }}
        </a-select-option>
      </a-select>
      <span style="margin-left: 12px">姓名或手机号：</span>
      <a-input allow-clear v-model="keyword" style="width: 10%"/>
      <span style="margin-left: 12px">年级：</span>
      <a-input allow-clear v-model="grade" style="width: 10%"/>
      <span style="margin-left: 12px">班级：</span>
      <a-input allow-clear v-model="className" style="width: 10%"/>
      <span style="margin-left: 12px">性别：</span>
      <a-select v-model="gender" :allowClear="true" style="width: 8%">
        <a-select-option value="male" key="male">
          男
        </a-select-option>
        <a-select-option value="female" key="female">
          女
        </a-select-option>
      </a-select>
      <br>
      <div style="margin-top:12px">
        <span>状态：</span>
        <a-select v-model="status" :allowClear="true" style="width: 10%">
          <a-select-option value="finished" key="finished">
            已完成
          </a-select-option>
          <a-select-option value="pending" key="pending">
            待支付
          </a-select-option>
          <a-select-option value="cancelled" key="cancelled">
            取消支付
          </a-select-option>
        </a-select>
        <span style="margin-left: 12px">充值类型：</span>
        <a-select v-model="type" :allowClear="true" style="width: 10%">
          <a-select-option value="semester" key="semester">
            学期卡
          </a-select-option>
          <a-select-option value="year" key="year">
            学年卡
          </a-select-option>
          <a-select-option value="month" key="month">
            月卡
          </a-select-option>
        </a-select>
      </div>
    </div>
    <div style="margin-bottom: 15px">
      <a-button type="primary" icon="search" style="margin-left: 15px" @click="handleSearch">查询</a-button>
      <a-button type="primary" icon="export" style="margin-left: 15px" @click="handleExport">导出</a-button>
    </div>
    <a-divider/>

    <a-table
        :columns="columns"
        :data-source="rows"
        :pagination="pagination"
        @change="handleTableChange"
        :loading="loading"
        size="middle"
        rowKey="id"
        bordered>
      <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>

      <span slot="orderTime" slot-scope="text">{{ text ? text : '' }}</span>
      <span slot="type" slot-scope="text, record">
        <span v-if="text === 'semester'">
          <a-tag color="blue">学期卡</a-tag>
        </span>
        <span v-if="text === 'year'">
          <a-tag color="purple">年卡</a-tag>
        </span>
        <span v-if="text === 'month'">
          <a-tag color="green">月卡</a-tag>
        </span>
      </span>
      <span slot="periodCount" slot-scope="text">{{ text ? text + '期' : '' }}</span>
      <span slot="status" slot-scope="text, record">
        <span v-if="text === 'pending'">
          <a-tag color="orange">待支付</a-tag>
        </span>
        <span v-if="text === 'finished'">
          <a-tag color="green">已完成</a-tag>
        </span>
        <span v-if="text === 'cancelled'">
          <a-tag color="red">取消支付</a-tag>
        </span>
      </span>
      <span slot="totalFinalPrice" slot-scope="text">{{ text ? text : '' }}</span>
      <!--      <template slot="action" slot-scope="text, record">
              <a-button :disabled="true" style="padding: 0 3px;" type="link">
                <a-icon type="edit"/>
                <span style="margin-left: 2px">详情</span>
              </a-button>
            </template>-->
    </a-table>
  </div>
</template>

<script>
import rechargeService from '@/service/recharge'
import bizOrgService from '@/service/bizOrg'
import {trim} from "core-js/internals/string-trim";

export default {
  name: "RechargeList",
  data() {
    return {
      columns: [
        {title: '#', scopedSlots: {customRender: 'serial'}, align: 'center'},
        {title: '学校', dataIndex: 'bizOrgName', align: 'center'},
        {title: '用户姓名', dataIndex: 'realName', align: 'center'},
        {title: '手机号', dataIndex: 'mobile', align: 'center'},
        {title: '年级', dataIndex: 'grade', align: 'center'},
        {title: '班级', dataIndex: 'className', align: 'center'},
        {title: '性别', dataIndex: 'genderDesc', align: 'center'},
        {title: '下单时间', dataIndex: 'orderTime', scopedSlots: {customRender: 'orderTime'}, align: 'center'},
        {title: '充值类型', dataIndex: 'type', scopedSlots: {customRender: 'type'}, align: 'center'},
        {title: '充值期数', dataIndex: 'periodCount', scopedSlots: {customRender: 'periodCount'}, align: 'center'},
        {title: '充值状态', dataIndex: 'status', scopedSlots: {customRender: 'status'}, align: 'center'},
        {
          title: '金额（元）',
          dataIndex: 'totalFinalPrice',
          scopedSlots: {customRender: 'totalFinalPrice'},
          align: 'center'
        },
        // {title: '操作', width: "10%", dataIndex: 'action', scopedSlots: {customRender: 'action'}, align: 'center'}
      ],
      rows: [],
      pagination: {},

      keyword: '',
      bizOrgId: null,
      grade: '',
      className: '',
      gender: null,

      bizOrgList: [],
      status: null,
      type: null,

      loading: false
    };
  },
  mounted() {
    let params = {
      current: 1,
      size: 10,
    }
    this.fetch(params)

    bizOrgService.queryBriefList().then((res) => {
      this.bizOrgList = res.data
    })
  },
  methods: {
    handleTableChange(pagination) {
      this.fetch(pagination)
    },
    handleSearch() {
      this.fetch()
    },
    handleExport() {
      this.keyword = trim(this.keyword)
      let params = {
        keyword: this.keyword,
        bizOrgId: this.bizOrgId,
        grade: this.grade,
        className: this.className,
        gender: this.gender,
        status: this.status,
        type: this.type
      }
      rechargeService.export(params);
    },
    fetch(page) {
      this.keyword = trim(this.keyword)
      let params = {
        current: page ? page.current : 1,
        size: page ? page.size : 10,
        keyword: this.keyword,
        bizOrgId: this.bizOrgId,
        grade: this.grade,
        className: this.className,
        gender: this.gender,
        status: this.status,
        type: this.type
      }
      this.loading = true
      rechargeService.queryPage(params).then((res) => {
        const pagination = {...this.pagination};
        this.rows = res.data.records
        pagination.current = res.data.current
        pagination.total = res.data.total
        pagination.size = res.data.size + ''
        pagination.showTotal = (total, range) => {
          return `${range[0]}-${range[1]} 总计 ${total} 条`
        }
        this.pagination = pagination
        this.loading = false
      }).catch(e => {
        this.loading = false
      })
    },
  }
}
</script>
